import Raven from 'raven-js';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import wrapWithErrorMonitoring from 'ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring';
import { SeatType } from '../common/api/fetchAvailableSeats';
import { sendRequestAdditionalSeatsNotification } from '../common/api/requestNotificationsApi';

/**
 * Used to convert the Pre-seats supported API names to the new seat types
 */
export const apiNameToSeatType = apiName => {
  switch (apiName) {
    case 'sales-hub-starter':
      return SeatType.SALES_STARTER;
    case 'sales-hub-professional':
      return SeatType.SALES_PRO;
    case 'sales-hub-enterprise':
      return SeatType.SALES_ENTERPRISE;
    case 'service-hub-starter':
      return SeatType.SERVICE_STARTER;
    case 'service-hub-professional':
      return SeatType.SERVICE_PROFESSIONAL;
    case 'service-hub-enterprise':
      return SeatType.SERVICE_ENTERPRISE;
    case 'commerce-hub-professional':
      return SeatType.COMMERCE_PROFESSIONAL;
    case 'commerce-hub-enterprise':
      return SeatType.COMMERCE_ENTERPRISE;
    default:
      return;
  }
};
export const requestAdditionalSeats = wrapWithErrorMonitoring('requestAdditionalSeats', ({
  apiName
}) => {
  return sendRequestAdditionalSeatsNotification({
    apiName,
    requestedSeatType: apiNameToSeatType(apiName)
  }).then(() => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request additional seats succeeded',
      apiName
    });
  }).catch(e => {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request additional seats failed',
      apiName
    });
    Raven.captureException(e);
    throw e;
  });
});